import React from 'react';
import { Link } from 'react-router-dom';
import './Footer.css';

export default function Footer() {
  return (
    <footer className="footer">
      <div className="container">
        <div className="footer-grid">
          <div className="footer-brand">
            <div className="f-logo">
              <div className="f-logo-mark">NG</div>
              <span className="f-logo-text">Next<span style={{color:'#fff'}}>GenHub Technology</span></span>
            </div>
            <p className="f-tagline">Scalable digital & AI solutions for growth-focused teams. Based in India — working globally.</p>
            <div className="f-socials">
              <a href="https://linkedin.com" target="_blank" rel="noopener noreferrer" className="f-social" aria-label="LinkedIn">in</a>
              <a href="https://twitter.com" target="_blank" rel="noopener noreferrer" className="f-social" aria-label="Twitter">𝕏</a>
              <a href="https://github.com" target="_blank" rel="noopener noreferrer" className="f-social" aria-label="GitHub">⌨</a>
              <a href="https://wa.me/919999999999" target="_blank" rel="noopener noreferrer" className="f-social" aria-label="WhatsApp">💬</a>
            </div>
          </div>
          <div className="f-col">
            <h4>Services</h4>
            <ul>
              <li><Link to="/services/web-development">Web Development</Link></li>
              <li><Link to="/services/mobile-app">Mobile Apps</Link></li>
              <li><Link to="/services/ai-solutions">AI Solutions</Link></li>
              <li><Link to="/services/digital-marketing">Digital Marketing</Link></li>
            </ul>
          </div>
          <div className="f-col">
            <h4>Company</h4>
            <ul>
              <li><Link to="/portfolio">Portfolio</Link></li>
              <li><Link to="/about">About Us</Link></li>
              <li><Link to="/blog">Blog</Link></li>
              <li><Link to="/contact">Careers</Link></li>
            </ul>
          </div>
          <div className="f-col">
            <h4>Contact</h4>
            <ul>
              <li><a href="mailto:info@nextgenhub.life">info@nextgenhub.life</a></li>
              <li><a href="tel:+917428951184">+91 742895 1184</a></li>
              <li><a href="https://wa.me/917428951184" target="_blank" rel="noopener noreferrer">WhatsApp</a></li>
              <li><Link to="/get-quote">Book a call</Link></li>
            </ul>
          </div>
        </div>
        <div className="footer-bottom">
          <span>© {new Date().getFullYear()} NextGenHub Life Pvt. Ltd.</span>
          <span>Privacy · Terms · Sitemap</span>
        </div>
      </div>
    </footer>
  );
}
